export const myWorks = [
  {
    id: 1,
    color: "black",
    projectImage: "assets/workImage/pizzaOrderApp.png",
    projectName: "SlicePizzeria ",
    projectDesc:
      "An app for ordering food online conveniently.",
    technology: "Node.js, Next.js, Prisma, Zustand, Toastify, NextAuth, Stripe, Cloudianry",
    project_link: "https://slicespizzeria.vercel.app",
    github_link: "https://github.com/Rajesh295-dev/pizzaStore",

  },
  {
    id: 2,
    color: "white",
    projectImage: "assets/workImage/nodeBlog.png",
    projectName: "Blog App",
    projectDesc: "This blog app lets users create, manage, and share content easily.",
    technology: "javascript, NodeJs, Express, jQuery, Bootstrap, Mongodb, Cloudianry",
    project_link: "https://react-blog-flax.vercel.app",
    github_link: "https://github.com/Rajesh295-dev/REACT_blog",

  },
  {
    id: 3,
    color: "white",
    projectImage: "assets/workImage/PWABudgetApp.png",
    projectName: "BudgetTracker",
    projectDesc:
      "This app allows users to track and manage all their expenses.",
    technology: " NodeJs, Express.js, bcrypt, Mongodb,  Mongoose, Morgan, Compression, Sequelize",
    project_link: "https://new-budget-tracker.vercel.app",
    github_link: "https://github.com/Rajesh295-dev/budgetTracker",

  },
  {
    id: 4,
    color: "white",
    projectImage: "assets/workImage/portFolio.png",
    projectName: "PortFolio",
    projectDesc:
      "My personal portfolio webiste",
    technology: "javascript, Nodejs, REACT, jQuery, Bootstrap, Fontawesome, devIcon",
    project_link: "https://me-rajesh.vercel.app",
    github_link: "https://github.com/Rajesh295-dev",

  },
  {
    id: 5,
    color: "white",
    projectImage: "assets/workImage/eventFinder.png",
    projectName: "EventFinder",
    projectDesc:
      "An app designed to generate event, brewery, and map details.",
    technology: "HTML, CSS, ULkit, momentJS, javascript,  jQuery, server-side APIs",
    project_link: "https://jhu-project1.github.io/Project1",
    github_link: "https://github.com/JHU-Project1/Project1?tab=readme-ov-file",

  },
  {
    id: 6,
    color: "white",
    projectImage: "assets/workImage/reactEstate.png",
    projectName: "reactEstate",
    projectDesc:
      "An app designed to streamline real estate management.",
    technology: "HTML, SCSS, React, Vite, javascript, Node.js, MERN-statck, Socket.io, JWT",
    project_link: "https://reactrealestate.vercel.app",
    github_link: "https://github.com/Rajesh295-dev/react_real_estate",

  },


];
